export function validateLineItemQuantity(quantity: number) {
  if (quantity < 1 || quantity > 1000000) {
    quantity = 1;
  }
  return quantity;
}
